export const CARDS_EXTENSION_TYPE = 'com.atlassian.confluence.link-cards';
export const CARDS_EXTENSION_KEY = 'cards';

export const CARDS_EXTENSION_ANALYTIC_SOURCE = 'cardsExtension';
export const CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE = 'cardsExtensionConfig';
export const CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE =
	'cardsExtensionConfigBackgroundColor';
export const CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE = 'cardsExtensionConfigBorderColor';
export const CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE = 'cardsExtensionConfigTextColor';

export const CARDS_EXTENSION_VERSION_2 = '2';
export const CARDS_EXTENSION_VERSION_3 = '3';
export const CARDS_EXTENSION_VERSION_4 = '4';
export const CARDS_EXTENSION_VERSION_5 = '5';

export const CARDS_IMAGES_V5: {
	alt: string;
	src: string;
}[] = [
	{
		src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
		alt: 'closed wooden window',
	},
	{
		src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
		alt: 'green coconut trees',
	},
	{
		src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
		alt: 'white and black striped chair',
	},
	{
		src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
		alt: 'surfboard on top of a cement wall',
	},
	{
		src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
		alt: 'white stairs',
	},
	{
		src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
		alt: 'swimming pool tiles',
	},
];
